import connect from './connect';
import UserDropdown from './UserDropdown';

export default connect(UserDropdown);
